
import React from "react"
import { Row, Col, Checkbox } from 'antd'
import type { CheckboxValueType } from 'antd/es/checkbox/Group'
import classes from './styles.module.css'
import { useTranslation } from "react-i18next"
import GlobusSvg from '../../img/svg/globus'

interface ListData {
  id: string
  item: string
}

interface Props{
  list: ListData[]
  // icon: JSX.Element
  checkBoxLists?: (list: CheckboxValueType[]) => void
}

const CheckBoxGroup: React.FC<Props> = ({list, checkBoxLists}) => {

  const { t } = useTranslation()

  return (
    <>
      {/* <div className={classes.divider}>{icon}&nbsp;&nbsp;{title}</div> */}
      <div className={classes.dividerMunicipality}><br/><GlobusSvg width={30} height={30} fill="#275674" /><span className={classes.dividerSpanMunicipality}>{t("Δήμος")}</span></div>
      <Checkbox.Group style={{ width: '100%' }} onChange={(list: CheckboxValueType[]) => checkBoxLists?.( list )}>
        <Row>
          {list.map((data:any) => {
            return (
              <Col key={data.id} span={24} className={classes.checkboxGroup}>
                <Checkbox value={data.item}>{t(data.item)}</Checkbox>
              </Col>
            )
          })}
        </Row>
      </Checkbox.Group>
    </>
  )

}
export default CheckBoxGroup